import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import { IconProps } from '../../icon/index.js'
import type Badge from './badge.vue'

// 定义组件props
export const badgeProps = buildProps({
  //  图标信息
  icon: {
    type: definePropType<IconProps>(Object),
    default: () => ({
      iconName: '',
      color: '',
      size: '',
    }),
  },
} as const)

// props
export type BadgeProps = ExtractPropTypes<typeof badgeProps>

// instance
export type BadgeInstance = InstanceType<typeof Badge>
